<template>
  <el-dialog
    top="0"
    :title="type === 1?'各项收入明细编辑':type === 2?'全年应收编辑':'全年核定收入编辑'"
    :visible.sync="incomeEditDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="1200px"
    center>

    <el-form :model="incomeForm" ref="incomeForm" label-position="left" label-width="40px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="社区">
            <el-input v-model="projectName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="小区">
            <el-input v-model="communityName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="年度">
            <el-input v-model="year" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="type === 1">
          <el-form-item label="月份">
            <el-select v-model="incomeForm.month" placeholder="请选择月份" @change="monthChange" style="width: 100%;">
              <el-option
                v-for="item in monthList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">一、单一甲方物业收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[0]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">二、住宅类物业费收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[1]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、统代管</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[2]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、社会化</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[3]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、三供分项居民</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[4]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">4、三供分项过渡费</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[5]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">5、非经、三供整体物业费</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[6]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">6、非经卫保费垃圾费</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[7]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">7、非经补贴</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[8]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">三、房屋租金收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[9]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、统代管市级</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[10]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、三供分项</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[11]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、非经租金返还</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[12]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">四、经营性房租收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[13]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">五、非经、三供一业物业委托管理费收入100%</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[14]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">六、特约服务收入（020、零维项目等）</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[15]">
                <template slot="append">元</template>
              </el-input>
            </div>

          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">七、停车收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[16]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between" slot="header">
              <span class="margin-right-xs">八、代收代缴收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[17]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">1、水费</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[18]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">2、电费</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[19]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="flex align-center justify-between margin-bottom-xs">
                  <span class="margin-right-xs">3、其他</span>
                  <el-input type="number" @input="setTotal" v-model="incomeForm.num[20]">
                    <template slot="append">元</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">九、物业费旧欠收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[21]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">十、房屋租金旧欠收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[22]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">十一、其他收入/多种经营收入</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[23]">
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>

        </el-col>
        <el-col :span="24">
          <el-card class="box-card">
            <div class="flex align-center justify-between">
              <span class="margin-right-xs">十二、合计</span>
              <el-input type="number" @input="setTotal" v-model="incomeForm.num[24]" disabled>
                <template slot="append">元</template>
              </el-input>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('incomeForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('incomeForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {monthList} from "@/utils/utils";
import {addMingXi, addQuanNianHeDingShouFu, addQuanNianYingShouFu, getOneMonthMingXi, getShuJuBiao} from "@/api/caiwu";

export default {
  name: "incomeEditDialog",
  props: {
    incomeEditDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default() {
        return 0;
      }
    },
    year: {
      type: Number,
      default() {
        return 0;
      }
    },
    project: {
      type: Number,
      default() {
        return 0;
      }
    },
    projectName: {
      type: String,
    },
    community: {
      type: Number,
      default() {
        return 0;
      }
    },
    communityName: {
      type: String,
    }
  },
  data() {
    return {
      monthList: monthList,
      incomeForm: {
        month: '',
        num: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      }
    }
  },
  created() {
  },
  components: {},
  methods: {

    //  获取收支明细
    async getInfo() {
      let _data = await getShuJuBiao(this.year, this.project, this.community)
      if (this.type === 2) {
        let _arr = []
        _data.data[0].xiangmu_one.map((item, index) => {
          _arr.push(item.quanNianYingShou ? item.quanNianYingShou : 0)
        })
        this.incomeForm.num = _arr
      }
      if (this.type === 3) {
        let _arr = []
        _data.data[0].xiangmu_one.map((item, index) => {
          _arr.push(item.heDingShouRu ? item.heDingShouRu : 0)
        })
        this.incomeForm.num = _arr
      }
    },


    async submitForm(formName) {
      if (!this.incomeForm.month && this.type === 1) return this.$message.error('请选择月份')
      this.incomeForm.num.map(item => {
        if (!item) item = 0
      })
      if (this.type === 1) {
        await addMingXi(this.project, this.community, this.year, this.incomeForm.month, 1, this.incomeForm.num.join(','))
      } else if (this.type === 2) {
        await addQuanNianYingShouFu(this.project, this.community, this.year, 1, this.incomeForm.num.join(','))
      } else if (this.type === 3) {
        await addQuanNianHeDingShouFu(this.project, this.community, this.year, 1, this.incomeForm.num.join(','))
      }

      this.$message.success('编辑成功')
      this.incomeForm.num = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.incomeForm.month = ''
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.incomeForm.num = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.incomeForm.month = ''
      this.$emit('cancelDialog', false)
    },
    monthChange(e) {
      this.incomeForm.month = e
      this.getOneMonthMingXi()
    },
    async getOneMonthMingXi() {
      let _arr = []
      if (this.type === 1) {
        let _data = await getOneMonthMingXi(this.project, this.community, this.year, this.incomeForm.month, 1)
        _data.data[0].xiangmu_one.map((item, index) => {
          _arr.push(item.Yue)
        })
      } else if (this.type === 2) {
        let _data = await getOneMonthMingXi(this.project, this.community, this.year, this.incomeForm.month, 1)
        _data.data[0].xiangmu_one.map((item, index) => {
          _arr.push(item.Yue)
        })
      } else if (this.type === 3) {
        let _data = await getOneMonthMingXi(this.project, this.community, this.year, this.incomeForm.month, 1)
        _data.data[0].xiangmu_one.map((item, index) => {
          _arr.push(item.Yue)
        })
      }
      this.incomeForm.num = _arr
    },
    setTotal() {
      let _mode2 = 0
      let _arr2 = [2, 3, 4, 5, 6, 7, 8]
      _arr2.map(item => {
        _mode2 += Number(this.incomeForm.num[item])
      })
      this.incomeForm.num[1] = _mode2.toFixed(2)
      let _mode3 = 0
      let _arr3 = [10, 11, 12]
      _arr3.map(item => {
        _mode3 += Number(this.incomeForm.num[item])
      })
      this.incomeForm.num[9] = _mode3.toFixed(2)
      let _mode8 = 0
      let _arr8 = [18, 19, 20]
      _arr8.map(item => {
        _mode8 += Number(this.incomeForm.num[item])
      })
      this.incomeForm.num[17] = _mode8.toFixed(2)
      let _total = 0
      this.incomeForm.num[24] = 0
      let _arrAll = [..._arr2, ..._arr3, ..._arr8]
      for (const key in this.incomeForm.num) {
        if (_arrAll.indexOf(Number(key)) === -1) {
          _total += Number(this.incomeForm.num[key])
        }
      }
      this.incomeForm.num[24] = _total.toFixed(2)
    }
  },
  filters: {},
  watch: {
    type() {
      if (this.type === 2 || this.type === 3) {
        this.getInfo()
      }
    }
  },
}
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;

  .el-input {
    width: 180px;
  }
}
</style>

